const Button = {
  variants: {
    primary: {
      bg: 'brand.500',
      color: 'white',
      borderRadius: '6px',
      fontWeight: '500',
      px: 5,
      _hover: {
        bg: 'brand.600',
        _disabled: { bg: 'brand.500' },
      },
      _active: { bg: 'brand.700' },
      transition: 'all 0.15s ease',
    },
    secondary: {
      bg: 'white',
      color: 'neutral.700',
      borderRadius: '6px',
      fontWeight: '500',
      border: '1px solid',
      borderColor: 'neutral.300',
      px: 5,
      _hover: {
        bg: 'neutral.50',
        borderColor: 'neutral.400',
      },
      _active: { bg: 'neutral.100' },
      transition: 'all 0.15s ease',
    },
    ghost: {
      bg: 'transparent',
      color: 'neutral.600',
      borderRadius: '6px',
      fontWeight: '500',
      _hover: { bg: 'neutral.100' },
      _active: { bg: 'neutral.200' },
      transition: 'all 0.15s ease',
    },
    danger: {
      bg: 'status.error',
      color: 'white',
      borderRadius: '6px',
      fontWeight: '500',
      px: 5,
      _hover: { bg: '#b03636' },
      _active: { bg: '#9a2f2f' },
      transition: 'all 0.15s ease',
    },
    adminPrimary: {
      bg: 'neutral.800',
      color: 'white',
      borderRadius: '6px',
      fontWeight: '500',
      px: 5,
      _hover: {
        bg: 'neutral.700',
        _disabled: { bg: 'neutral.800' },
      },
      _active: { bg: 'neutral.900' },
      transition: 'all 0.15s ease',
    },
    adminSecondary: {
      bg: 'white',
      color: 'neutral.700',
      borderRadius: '6px',
      fontWeight: '500',
      border: '1px solid',
      borderColor: 'neutral.300',
      px: 5,
      _hover: {
        bg: 'neutral.50',
        borderColor: 'neutral.400',
      },
      _active: { bg: 'neutral.100' },
      transition: 'all 0.15s ease',
    },
    adminDanger: {
      bg: 'status.error',
      color: 'white',
      borderRadius: '6px',
      fontWeight: '500',
      px: 5,
      _hover: { bg: '#b03636' },
      _active: { bg: '#9a2f2f' },
      transition: 'all 0.15s ease',
    },
  },
};

export default Button;
